import React from 'react';
import { Link } from 'react-router-dom';
import { ADMIN_DATE_PLACEHOLDER } from './adminUserDisplay';
import { ADMIN_KPI_CARD_DEFS } from './adminDashboardDisplay';

function formatKpiValue(kpis, valueKey) {
  const value = kpis?.[valueKey];
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  return ADMIN_DATE_PLACEHOLDER;
}

export default function AdminKpiCards({ kpis, t }) {
  return (
    <section aria-label={t('admin.home.kpisTitle')}>
      <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-3">
        {ADMIN_KPI_CARD_DEFS.map((card) => (
          <Link
            key={card.id}
            to={card.href}
            className="rounded-xl border border-slate-200 bg-white p-4 hover:border-indigo-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            <p className="text-sm font-medium text-slate-600">{t(card.titleKey)}</p>
            <p className="mt-2 text-3xl font-semibold tabular-nums text-slate-900">
              {formatKpiValue(kpis, card.valueKey)}
            </p>
            {card.hintKey ? (
              <p className="mt-2 text-xs leading-snug text-slate-500">{t(card.hintKey)}</p>
            ) : null}
          </Link>
        ))}
      </div>
    </section>
  );
}
